import React from 'react';
import RichTextEditor from 'react-rte';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { injectIntl } from 'react-intl';


@injectIntl
export default class TextEditor extends React.Component {
  static propTypes = {
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    const value = props.value == undefined ? '-' : props.value;
    this.state = {
      value: RichTextEditor.createValueFromString(value, 'html'),
      readOnly: props.readOnly
    };
  }

  onChange = value => {
    this.setState({ value });
  };

  render() {
    const { intl, readOnly } = this.props;
    return (
      <div>
        <RichTextEditor
          readOnly={this.state.readOnly}
          value={this.state.value}
          onChange={this.onChange}
        />
        <br />
        <ButtonToolbar>
          <Button onClick={() => this.props.onClose()}>
            {intl.formatMessage({ id: 'close' })}
          </Button>
          <Button
            bsStyle={'primary'}
            onClick={() => this.props.onSave(this.state.value.toString('html'))}
          >
            {intl.formatMessage({ id: 'save' })}
          </Button>
        </ButtonToolbar>
      </div>
    );
  }
}
